export const TRACK_SLIDER_MIN = 0;
export const TRACK_SLIDER_MAX = 999;
export const TRACK_SLIDER_DEFAULT_STATE_VALUE = -1;
export const TRACK_SLIDER_STEP = 1;
